import Vue from 'vue'
import Vuex from 'vuex'
import ResultPanel from '../../components/Collections/ResultPanel'

const algoliasearchV4 = require('algoliasearch')

Vue.use({
  install(Vue) {
    const Algolia = algoliasearchV4(window.zubluAlgolia.applicationID, window.zubluAlgolia.publicAPIKey)
    const liveaboardIndex = Algolia.initIndex(window.zubluAlgolia.liveaboardIndex)
    const resortIndex = Algolia.initIndex(window.zubluAlgolia.resortIndex)

    Vue.prototype.$algolia = {
      instance: Algolia,
      searchAllLiveaboards: function ({ facetFilters, numericFilters }) {
        return new Promise((resolve, reject) => {
          liveaboardIndex.search('', {
            facetFilters,
            numericFilters,
            hitsPerPage: 1000
          })
          .then(resolve)
          .catch(reject)
        })
      },
      searchAllResorts: function ({ facetFilters, numericFilters }) {
        return new Promise((resolve, reject) => {
          resortIndex.search('', {
            facetFilters,
            numericFilters,
            hitsPerPage: 1000
          })
          .then(resolve)
          .catch(reject)
        })
      },
    }
  }
})

Vue.use(Vuex)

Vue.component('result-panel', ResultPanel)

const apps = document.querySelectorAll('.vue-app');

Array.prototype.forEach.call(apps, el => new Vue({
  el,
  template: el.innerHTML
}))
